import number1 from "./1.png";
import number2 from "./2.png";
import number3 from "./3.png";
import number4 from "./4.png";
import number5 from "./5.png";
import number6 from "./6.png";
import number7 from "./7.png";
import number8 from "./8.png";

export const numberImages = {number1, number2, number3, number4, number5, number6, number7, number8};